import { siteMaps } from '../site-maps'
import { siteMapNavItem } from '../types/siteMap'
import store from '../store'

export const updateNav = ({
  item,
  random,
}: {
  item: any
  random?: boolean
}) => {
  // this does nothing
  return null
}

export const getSiteMap = (map: string): siteMapNavItem[] => {
  return siteMaps[map as keyof typeof siteMaps]
}

export const getItemsFromPath = (path: string) => {
  const split = path.split('/')
  return {
    view: split[1],
    code: split[2],
  }
}

export const itemExistsInNav = (id: number, nav: siteMapNavItem[]) => {
  return nav.some((item: siteMapNavItem) => item.id === id)
}

export const pageVisited = (pageName: string): boolean => {
  const { siteMap } = store.getState()
  return !!siteMap?.nav.find((item: siteMapNavItem) => item.path === pageName)
}
